import actions from "@/store/modules/user/actions";
import mutations from "@/store/modules/user/mutations";
import state from "@/store/modules/user/state";

export default {
    actions,
    mutations,
    state
}